module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAADCAYAAABMFFUxAAAAE0lEQVQYV2M0Njb+z0AmYBwwzQA6CQTMH4NoDwAAAABJRU5ErkJggg=="